<div [ngSwitch]="type">
  <!-- Skeleton default, can have different class name -->
  <ion-skeleton-text
    *ngSwitchDefault
    animated
    [ngClass]="className"
  ></ion-skeleton-text>

  <!-- Skeleton for text heading -->
  <ion-list *ngSwitchCase="'heading'" lines="none">
    <div
      class="input-text"
      *ngFor="let item of [].constructor(numOptions); let i = index"
    >
      <ion-skeleton-text
        animated
        class="card-sm"
        style="width: 30%"
      ></ion-skeleton-text>
    </div>
  </ion-list>

  <ion-list *ngSwitchCase="'paragraph'" lines="none">
    <div
      class="input-text"
      *ngFor="let item of [].constructor(numOptions); let i = index"
    >
      <ion-skeleton-text
        animated
        class="text left"
        style="width: 100%"
      ></ion-skeleton-text>
    </div>
  </ion-list>

  <!-- Skeleton for radio field -->
  <ion-list *ngSwitchCase="'radio'" lines="none">
    <ion-skeleton-text animated class="text left"></ion-skeleton-text>
    <ion-item *ngFor="let item of [].constructor(numOptions); let i = index">
      <ion-radio slot="end" [disabled]="true">
        <ion-skeleton-text animated width="80%"></ion-skeleton-text
      ></ion-radio>
    </ion-item>
  </ion-list>

  <!-- Skeleton for input fields -->
  <ion-list *ngSwitchCase="'text'" lines="none">
    <div
      class="input-text"
      *ngFor="let item of [].constructor(numOptions); let i = index"
    >
      <ion-skeleton-text animated class="left text"></ion-skeleton-text>
      <ion-skeleton-text animated class="card-sm"></ion-skeleton-text>
    </div>
  </ion-list>

  <!-- Skeleton for text area -->
  <ion-list *ngSwitchCase="'textarea'" lines="none">
    <div
      class="input-textarea"
      *ngFor="let item of [].constructor(numOptions); let i = index"
    >
      <ion-skeleton-text animated class="left text"></ion-skeleton-text>
      <ion-skeleton-text
        animated
        [ngClass]="i % 2 == 0 ? 'card-md' : 'card-sm'"
      ></ion-skeleton-text>
    </div>
  </ion-list>

  <!-- Skeleton for checkbox -->
  <ion-list *ngSwitchCase="'checkbox'" lines="none">
    <div
      class="input-checkbox"
      *ngFor="let item of [].constructor(numOptions); let i = index"
    >
      <ion-label>
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-label>
      <ion-checkbox slot="end" [disabled]="true"></ion-checkbox>
    </div>
  </ion-list>

  <!-- Skeleton for form controls -->
  <ion-grid *ngSwitchCase="'formControls'" class="form-controls">
    <ion-row class="ion-justify-content-between">
      <ion-col size="3">
        <bepatient-skeleton
          className="button left bp-margin-bottom-half"
        ></bepatient-skeleton>
      </ion-col>
      <ion-col size="3">
        <bepatient-skeleton
          className="button right bp-margin-bottom-half"
        ></bepatient-skeleton>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Template: My form skeleton -->
  <div *ngSwitchCase="'my-form-template'" class="my-form-skeleton">
    <bepatient-skeleton
      className="progress-bar ion-margin-top"
    ></bepatient-skeleton>
    <div class="form ion-padding">
      <bepatient-skeleton className="text left"></bepatient-skeleton>
      <bepatient-skeleton className="divider"></bepatient-skeleton>
      <bepatient-skeleton [type]="'text'" [numOptions]="1"></bepatient-skeleton>
      <bepatient-skeleton
        [type]="'radio'"
        [numOptions]="2"
      ></bepatient-skeleton>
      <bepatient-skeleton
        [type]="'textarea'"
        [numOptions]="1"
      ></bepatient-skeleton>
      <bepatient-skeleton
        [type]="'checkbox'"
        [numOptions]="1"
      ></bepatient-skeleton>
      <bepatient-skeleton [type]="'formControls'"></bepatient-skeleton>
    </div>
  </div>
</div>
